import type { DocumentUpdateSummary } from "@ohf/core";

/** Completion and current-role applicability are independent of account readiness. */
export function documentIsOutstanding(document: DocumentUpdateSummary["documents"][number]) {
  return document.required !== false && !["signed", "prior_complete", "overridden", "uploaded"].includes(document.status);
}

export function personalDocumentView(search: string, hash = "") {
  const view = new URLSearchParams(search).get("view");
  return view === "practice-follow-up" || (!view && hash === "#practice-follow-up") ? "practice-follow-up" : "personal";
}
